// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"e8fb787f","169":"66b19941","559":"4b05e7dd","881":"3f2ed2d8","969":"a4321028"}[chunkId] + ".chunk.js";
};